import SectionBadge from "@/components/site/SectionBadge";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQS = [
  {
    q: "What does BLEZZINGS Growth Partners do?",
    a: "BLEZZINGS Growth Partners is a Bengaluru-based sales and marketing transformation firm. We help businesses grow revenue and profit by connecting commercial strategy, market intelligence, brand, marketing, sales, digital and e-commerce — and by staying involved through execution, not just strategy.",
  },
  {
    q: "How is BLEZZINGS different from a traditional consulting firm?",
    a: "Traditional consulting often ends with a recommendation. We work alongside your team to implement it — pricing, distribution, sales systems, marketing and digital — and we measure success in commercial results such as revenue, margin and market share.",
  },
  {
    q: "How is BLEZZINGS different from a marketing agency?",
    a: "Agencies typically execute campaigns within one channel. We start with the commercial problem — portfolio, pricing, positioning, distribution or digital economics — and then shape marketing and sales activity to solve it, so activity is tied to profitable growth.",
  },
  {
    q: "What types of businesses does BLEZZINGS work with?",
    a: "We work with founder-led and established businesses in consumer durables, FMCG, retail, D2C and e-commerce, manufacturing and B2B, education, media, real estate and professional services — typically when growth has stalled, margins are under pressure or a new market is being entered.",
  },
  {
    q: "Does BLEZZINGS work only in India?",
    a: "We are based in Bengaluru and work with businesses across India. Our leadership has also delivered programmes for organisations in the US, UK, UAE, Saudi Arabia, Germany, Australia and other markets, and we take on international engagements where there is a strong fit.",
  },
  {
    q: "Can BLEZZINGS support both strategy and execution?",
    a: "Yes. Most engagements run from diagnosis and strategy through design, rollout and optimisation. We can lead the full journey or step in at the stage where you need the most support.",
  },
  {
    q: "How do we start an engagement?",
    a: "Share your growth challenge through our contact form, WhatsApp or phone. We reply within one business day, arrange an initial discussion to understand the problem, and then propose a focused diagnostic or engagement scope.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-4">
          <SectionBadge label="FAQs" />
          <h2 className="font-serif-display text-4xl sm:text-5xl mt-6 leading-[1.05]">
            Answers, <br />
            upfront.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-black/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl text-black hover:no-underline hover:text-zinc-500 transition-colors duration-300 py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  forceMount
                  className="text-zinc-700 leading-relaxed text-[15px] pb-5"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
